import type { IGrid } from "./types"
import css from './index.module.scss'


/** Компонент Grid */
export const Grid = (props: IGrid) => {
    const getGridTemplate = () => {
        const gridTemplateColumnStyle: React.CSSProperties = {
            gap: props.gap,
            alignItems: props.alignItems,
            justifyContent: props.justifyContent,
            gridTemplateColumns: props.gridTemplateColumns,
        }

        const gridTemplateRowsStyle: React.CSSProperties = {
            gap: props.gap,
            alignItems: props.alignItems,
            justifyContent: props.justifyContent,
            gridTemplateRows: props.gridTemplateRows,
        }

        switch (props.gridTemplate) {
            case 'columns': return gridTemplateColumnStyle
            case 'rows': return gridTemplateRowsStyle
            default: return gridTemplateColumnStyle
        }
    }

    return <>
        <div style={getGridTemplate()} className={`${css.grid} ${props.className}`}>
            {props.children}
        </div>
    </>
}